import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/site";
import { Logo } from "./Header";

const serviceLinks = [
  { label: "Taxi Van Paris", to: "/taxi-van-paris/" },
  { label: "Taxi 7–8 places", to: "/reserver-taxi-7-places/" },
  { label: "Taxi CDG", to: "/taxi-cdg/" },
  { label: "Taxi Orly", to: "/taxi-orly/" },
  { label: "Taxi Disneyland Paris", to: "/taxi-disneyland-paris/" },
  { label: "Taxi Gare de Paris", to: "/taxi-gare-paris/" },
  { label: "Taxi Versailles", to: "/taxi-versailles/" },
  { label: "Chauffeur privé Paris", to: "/chauffeur-prive-paris/" },
];

const siteLinks = [
  { label: "Nos véhicules", to: "/nos-vehicules/" },
  { label: "Services", to: "/services/" },
  { label: "Destinations", to: "/destinations/" },
  { label: "Tarifs", to: "/tarifs/" },
  { label: "À propos", to: "/a-propos/" },
  { label: "Blog", to: "/blog/" },
  { label: "Contact", to: "/contact/" },
];

const legalLinks = [
  { label: "Mentions légales", to: "/mentions-legales/" },
  { label: "Politique de confidentialité", to: "/politique-confidentialite/" },
  { label: "Conditions générales", to: "/conditions-generales/" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy-950 text-white">
      <div className="container-site grid gap-12 py-16 sm:py-20 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo dark />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
            CAB CITY — taxi van et chauffeur privé à Paris et en Île-de-France. Mercedes Classe V jusqu'à 8 passagers,
            transferts aéroports, gares et Disneyland Paris.
          </p>
          <a
            href={PHONE_TEL}
            data-testid="footer-phone-link"
            className="mt-6 inline-flex items-center gap-2.5 rounded-xl bg-ccblue px-5 py-3 font-heading text-sm font-bold text-white transition-colors hover:bg-ccblue-700"
          >
            <Phone size={16} strokeWidth={2.4} />
            {PHONE_DISPLAY}
          </a>
          <p className="mt-4 flex items-center gap-2 text-xs text-white/45">
            <MapPin size={13} /> Paris &amp; Île-de-France
          </p>
        </div>
        <nav aria-label="Nos services">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.22em] text-ccblue-200">Nos services</h2>
          <ul className="mt-5 space-y-2.5">
            {serviceLinks.map((l) => (
              <li key={l.to}>
                <Link data-testid="footer-nav-link" to={l.to} className="text-sm text-white/70 transition-colors hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Le site">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.22em] text-ccblue-200">Le site</h2>
          <ul className="mt-5 space-y-2.5">
            {siteLinks.map((l) => (
              <li key={l.to}>
                <Link data-testid="footer-nav-link" to={l.to} className="text-sm text-white/70 transition-colors hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Informations légales">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.22em] text-ccblue-200">Informations</h2>
          <ul className="mt-5 space-y-2.5">
            {legalLinks.map((l) => (
              <li key={l.to}>
                <Link data-testid="legal-link" to={l.to} className="text-sm text-white/70 transition-colors hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <button
            type="button"
            data-testid="footer-cookie-settings"
            onClick={() => window.dispatchEvent(new CustomEvent("cabcity:open-cookie-settings"))}
            className="mt-7 inline-flex items-center gap-2 text-sm font-heading font-semibold text-white/60 transition-colors hover:text-white"
          >
            Gérer mes cookies
          </button>
          <a href="#reserver" data-testid="footer-cta-booking" className="booking-cta mt-4 inline-flex items-center gap-2 font-heading text-sm font-bold text-ccblue-200 transition-colors hover:text-white">
            Réserver mon trajet →
          </a>
        </nav>
      </div>
      <div className="border-t border-white/10">
        <div className="container-site flex flex-col items-center justify-between gap-3 py-6 text-xs text-white/40 sm:flex-row">
          <p>© {new Date().getFullYear()} CAB CITY — Tous droits réservés.</p>
          <p>Taxi Van Paris · Mercedes Classe V · Jusqu'à 8 passagers</p>
        </div>
      </div>
    </footer>
  );
}
